export default "__VITE_ASSET__yJdj3rGy__"